import React from 'react'


export default function Footer() {
    return <>
        <footer className=" fixed-bottom bg-transparent">
        <div className="container">
                <div className="position-relative">
                    <div className="position-absolute bottom-0 end-0 py-2 " >
                         {/* <img src={require('../../images/logo.jpg')} alt="palestine flag ipg " className='' width={70}/> */}
                             <span className='fw-bold  d-block '>By Ayaa Hassan</span> 
                            <span >Copyright©2024</span>
                  
                    </div>
              
             </div>




    </div>
    
    
    </footer>
    
    
    </>
  
}
